import React from '../services/React';
import InlineMenu from './InlineMenu.jsx';
import './DrilldownMenuList.css';

function DrilldownMenuList({ items = [] }) {
  const itemsHTML = items.map(({
    label,
    subLabel,
    menuItems,
    ...otherProps
  }) => {
    let menuHTML;
    let subLabelHTML;

    if (menuItems && menuItems.length) {
      menuHTML = <InlineMenu items={menuItems} />;
    }

    if (subLabel) {
      subLabelHTML = (
        <span className="DrilldownMenuList__Item__SubLabel">{subLabel}</span>
      );
    }

    return (
      <li className="DrilldownMenuList__Item" {...otherProps}>
        <span className="DrilldownMenuList__Item__Label">
          {label}
          {subLabelHTML}
        </span>
        {menuHTML}
      </li>
    );
  });

  return (
    <ul className="DrilldownMenuList">
      {itemsHTML}
    </ul>
  );
}

export default DrilldownMenuList;



// WEBPACK FOOTER //
// ./src/commons/components/DrilldownMenuList.jsx